module.exports = __webpack_public_path__ + "static/media/iconNoteActive.9a0efb1c.svg";